import { styled, Typography } from "@mui/material";

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.light,
  fontWeight: 600,
  letterSpacing: 0.05,
  lineHeight: 1.3,
}));
